/**
 * Investor Distribution React Query Hooks
 *
 * Hooks for fetching investor-specific distribution data
 */

import { useApiQuery } from '@/hooks/react-query/useApiQuery';
import { portalQueryKeys } from '@/portal/shared/hooks/queryKeys';
import {
  InvestorDistributionService,
  InvestorDistributionsList,
  InvestorDistributionDetail,
} from '../services/distributions-service';

/**
 * Hook to fetch all distributions for the current investor
 */
export const useInvestorDistributions = () => {
  return useApiQuery<InvestorDistributionsList>(
    portalQueryKeys.transactions.distributions(),
    () => InvestorDistributionService.getInvestorDistributions()
  );
};

/**
 * Hook to fetch detailed information about a specific distribution
 */
export const useInvestorDistributionDetail = (
  distributionId: string | null
) => {
  return useApiQuery<InvestorDistributionDetail>(
    [...portalQueryKeys.transactions.distributions(), distributionId],
    () =>
      InvestorDistributionService.getInvestorDistributionDetail(
        distributionId!
      ),
    {
      enabled: !!distributionId,
    }
  );
};
